import React from 'react';
import Hero from '../components/Hero';
import PolicyLayout from '../components/PolicyLayout';

const PrivacyPolicy = () => {
    const sections = [
        { h: "1. Data Collection", p: "We collect information you provide directly to us, such as name, email, and project details when you contact RojrzTech." },
        { h: "2. Usage of Data", p: "Your data is used to improve our services, communicate project updates, and ensure a seamless development experience." },
        { h: "3. Cookie Policy", p: "We use cookies to understand how you interact with our website to enhance your browsing experience." },
        { h: "4. Third-Party Sharing", p: "We do not sell or trade your personal information. Data is shared only with trusted partners for operational purposes." },
        { h: "5. Security Measures", p: "We implement industry-standard encryption to protect your sensitive codebase and personal information." },
        { h: "6. User Rights", p: "You have the right to request access, correction, or deletion of your personal data at any time." },
        { h: "7. Children's Privacy", p: "Our services are not intended for individuals under the age of 13. We do not knowingly collect child data." },
        { h: "8. Changes to Policy", p: "We may update this policy periodically. Please review this page for any significant changes." },
        { h: "9. Data Retention", p: "We retain your data only as long as necessary to provide the services you have requested." },
        { h: "10. Contact Us", p: "If you have questions about this Privacy Policy, please reach out to our support team." }
    ];

    return (
        <>

            <Hero
                badge="Privacy & Legal"
                title="Privacy Policy"
                subtitle="We value your trust. Learn how we collect, use, and protect your data securely."
                image="https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800"
                primaryBtnText="Contact Support"
                primaryBtnLink="/contact"
                rating="4.9/5.0"
                clientCount="500+"
            />

            {/* 3. PolicyLayout yahan se shuru hoga */}
            <PolicyLayout title="" seoLabel=""> {/* Title empty chod do agar Hero use kar rahe ho */}
                <div className="space-y-12">
                    {sections.map((sec, i) => (
                        <div key={i}>
                            <h3 className="text-2xl font-bold text-[#F3CA52] mb-4">{sec.h}</h3>
                            <p className="text-zinc-400 leading-relaxed text-[#FFFFFF]">{sec.p}</p>
                        </div>
                    ))}
                </div>
            </PolicyLayout>
        </>
    );
};

export default PrivacyPolicy;